import { render, staticRenderFns } from "./idxGame05.vue?vue&type=template&id=2afe6aa1&"
import script from "./idxGame05.vue?vue&type=script&lang=js&"
export * from "./idxGame05.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports